import restUtils from "core/utils/rest";
import { DocumentUploadPayload, DocumentUploadResponse, InvestorAmlDocument, investorAmlDocumentTransformer } from "./transformers/document";

export const upload = (file: File, payload: DocumentUploadPayload): Promise<DocumentUploadResponse> => {
  const url = "hubwise-api/dms/documents";
  const data = new FormData();
  data.append("file", file);
  data.append("public", String(payload.isPublic ?? true));
  data.append("metadata", JSON.stringify({ customerId: payload.customerId, investorId: payload.investorId, category: payload.docVaultCategory }));
  return restUtils.call("PortalApi", url, "POST", data).then((response: any) => {
    return response.payload as DocumentUploadResponse;
  });
};

export const getLink = (urn: string): Promise<string> => {
  const url = `hubwise-api/dms/documents/${urn}:1/download`;
  return restUtils.call("PortalApi", url, "GET").then((response: any) => {
    if (!response?.payload?.link) {
      throw new Error("Failed to fetch document download link.");
    }
    return response.payload.link;
  });
};

export const getInvestorAmlDocuments = (investorId: string) => {
  const url = `hubwise-api/aml/documents/${investorId}`;
  return restUtils.call("PortalApi", url, "GET").then((response: any): InvestorAmlDocument[] => {
    return response.rows.map(investorAmlDocumentTransformer);
  });
};
